export enum RoleEnum {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_ADVERTISER = "ROLE_ADVERTISER",
  ROLE_LOCATION = "ROLE_LOCATION",
  ROLE_FRANCHISE = "ROLE_FRANCHISE"
}

export const RoleEnumMapping: Record<RoleEnum, string> = {
  [RoleEnum.ROLE_ADMIN]: "Admin",
  [RoleEnum.ROLE_ADVERTISER]: "Advertiser",
  [RoleEnum.ROLE_LOCATION]: "Location partner",
  [RoleEnum.ROLE_FRANCHISE]: "Franchise"
};
export interface RoleNamesInterface {
  id: RoleEnum;
  value: string;
}
